// @ts-nocheck
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {toast} from "@/components";
import useCreateTransfer from "../../hooks/wallet/useCreateTransfer";
import {useBalanceStore} from "../../store/useBalance.store";
import {useCurrentAndSelectedContactStore} from "../../store/Wallet/useTransfer.store";
import CustomSteps from "../CustomSteps";
import TransferAmount from "./components/TransferAmount";
import TransferConfirm from "./components/TransferConfirm";
import TransferUserId from "./components/TransferUserId";

// â”€â”€â”€ Shared button styles â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const PrimaryBtn = ({onClick, disabled, children}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        height: 40,
        minWidth: 110,
        borderRadius: 999,
        border: "none",
        background: disabled
          ? "rgba(255,255,255,0.1)"
          : hovered
            ? "linear-gradient(135deg,#c04400,#a0207a)"
            : "linear-gradient(135deg,#fa5400,#d732a8)",
        color: disabled ? "rgba(255,255,255,0.3)" : "#fff",
        fontWeight: 700,
        fontSize: 14,
        padding: "0 24px",
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "background 0.2s, opacity 0.2s",
      }}
    >
      {children}
    </button>
  );
};

const GhostBtn = ({onClick, children}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        height: 40,
        minWidth: 110,
        borderRadius: 999,
        border: "1.5px solid rgba(215,50,168,0.45)",
        background: hovered ? "rgba(215,50,168,0.12)" : "transparent",
        color: "rgba(215,50,168,0.9)",
        fontWeight: 600,
        fontSize: 14,
        padding: "0 24px",
        cursor: "pointer",
        transition: "background 0.2s, border-color 0.2s",
      }}
    >
      {children}
    </button>
  );
};

const CancelBtn = ({onClick, children}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        height: 40,
        minWidth: 110,
        borderRadius: 999,
        border: hovered ? "1.5px solid transparent" : "1.5px solid rgba(215,50,168,0.4)",
        background: hovered ? "linear-gradient(135deg,#fa5400,#d732a8)" : "transparent",
        color: hovered ? "#fff" : "rgba(215,50,168,0.75)",
        fontWeight: 600,
        fontSize: 14,
        padding: "0 24px",
        cursor: "pointer",
        transition: "background 0.2s, border-color 0.2s, color 0.2s",
      }}
    >
      {children}
    </button>
  );
};

// â”€â”€â”€ Main component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const TransferSteps = () => {
  const [transferAmount, setTransferAmount] = useState(0);
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const {requestSendMoney, isPending, isError, isSuccess} = useCreateTransfer();
  const handleTransferModal = useBalanceStore(state => state.handleTransferModal);
  const current = useCurrentAndSelectedContactStore(state => state.current);
  const setCurrent = useCurrentAndSelectedContactStore(state => state.setCurrent);
  const selectedContact = useCurrentAndSelectedContactStore(state => state.selectedContact);
  const setSelectedContact = useCurrentAndSelectedContactStore(state => state.setSelectedContact);

  const {t} = useTranslation();

  const steps = [
    {
      title: t("transferStepsBeneficiary"),
      content: (
        <TransferUserId
          selectedContact={selectedContact}
          setSelectedContact={setSelectedContact}
          setIsNextDisabled={setIsNextDisabled}
        />
      ),
    },
    {
      title: t("transferStepsAmount"),
      content: (
        <TransferAmount
          transferAmount={transferAmount}
          setTransferAmount={setTransferAmount}
          setIsNextDisabled={setIsNextDisabled}
        />
      ),
    },
    {
      title: t("transferStepsTransfer"),
      content: (
        <TransferConfirm
          transferContact={selectedContact}
          transferAmount={transferAmount}
        />
      ),
    },
  ];

  const resetTransferState = () => {
    setTransferAmount(0);
    setSelectedContact({});
    setCurrent(0);
  };

  const next = () => setCurrent(current + 1);

  const prev = () => {
    setCurrent(current - 1);
    if (current - 1 === 0 && selectedContact?.id) setIsNextDisabled(false);
  };

  const handleConfirm = () => {
    requestSendMoney({
      amount: Number(transferAmount),
      receiver_id: selectedContact.id,
    });
    resetTransferState();
    handleTransferModal();
  };

  useEffect(() => {
    if (isError) {
      toast.error(`${t("transferStepsError")} â€” ${t("transferStepsErrorDesc_1")}`);
    } else if (isSuccess) {
      toast.success(`${t("transferStepsSuccess")} â€” ${t("transferStepsSuccessMessage")}`);
    }
  }, [isError, isSuccess, t]);

  const contentStyle = {
    textAlign: "center",
    color: "var(--color-text-secondary)",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(215,50,168,0.15)",
    borderRadius: 16,
    marginTop: 16,
    padding: "20px 24px",
    minHeight: 140,
  };

  return (
    <div style={{minWidth: "100%", margin: "0 auto", paddingTop: 20}}>
      <CustomSteps steps={steps} current={current} />

      <div style={contentStyle}>{steps[current].content}</div>

      <div style={{marginTop: 24, display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap"}}>
        {current === 0 && (
          <>
            <PrimaryBtn onClick={next} disabled={isNextDisabled}>
              {t("transferStepsNext")}
            </PrimaryBtn>
            <CancelBtn onClick={() => { resetTransferState(); handleTransferModal(); }}>
              {t("transferStepsCancel")}
            </CancelBtn>
          </>
        )}
        {current === 1 && (
          <>
            <PrimaryBtn onClick={next} disabled={isNextDisabled}>
              {t("transferStepsNext")}
            </PrimaryBtn>
            <GhostBtn onClick={prev}>
              {t("transferStepsBack")}
            </GhostBtn>
            <CancelBtn onClick={() => { resetTransferState(); handleTransferModal(); }}>
              {t("transferStepsCancel")}
            </CancelBtn>
          </>
        )}
        {current === 2 && (
          <>
            <PrimaryBtn onClick={handleConfirm} disabled={isPending}>
              {t("transferStepsConfirm")}
            </PrimaryBtn>
            <GhostBtn onClick={prev}>
              {t("transferStepsBack")}
            </GhostBtn>
            <CancelBtn onClick={() => { resetTransferState(); handleTransferModal(); }}>
              {t("transferStepsCancel")}
            </CancelBtn>
          </>
        )}
      </div>
    </div>
  );
};

export default TransferSteps;
